import React, { Fragment } from "react";

export default function Tag({ children, className, size, backgroundColor, color, isRound=true }) {
    return <span className={`tag ${isRound ? 'round' : ''} ${className !== undefined ? className : ''} ${size != undefined ? size : ''}`} style={{ backgroundColor, color, border: `1px solid ${backgroundColor}` }}>{children}</span>;
}